import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to run service locally
// envUrls.leadershipService = 'http://localhost:5089/leadership/';

export default class LeadershipService {
  async fetchLeaders(payload) {
    return await axiosInstance
      .post(`${envUrls.leadershipService}fetch/leadership`, payload)
      .then((response) => response.data);
  }
}
